import React, { lazy, Suspense } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { setClaritySesion, useUserContext } from '../core';

const LoginPage = lazy(() => import('../pages/login/index').then((m) => ({ default: m.LoginPage })));
const SistemContextController = lazy(() => import('../pages/sistema/sistemController').then((m) => ({ default: m.SistemContextController })));
const ObservatorioPage = lazy(() => import('../pages/observatorio/observatorio'));
const LeiturasObservatorioPage = lazy(() => import('../pages/observatorio/leituras/LeiturasObservatorio'));
const LandingPage = lazy(() => import('../pages/landingPage/landingPage').then((m) => ({ default: m.LandingPage })));

type PrivateRouteProps = {
    children?: React.ReactNode;
};

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const { user } = useUserContext();
    if (user === null) return <Navigate to="/login" />;
    return children ? <>{children}</> : null;
};

export const AppRoutes: React.FC = () => {
    //Inicializando o clarity para o usuário corrente
    const userContext = useUserContext();
    setClaritySesion(userContext.user?.email);

    return (
        <BrowserRouter>
            <Suspense fallback={null}>
                <Routes>
                    <Route path="/" element={<ObservatorioPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/observatorio" element={<ObservatorioPage />} />
                    <Route path="/observatorio/leituras/:observatorioId" element={<LeiturasObservatorioPage />} />
                    <Route path="/landing" element={<LandingPage />} />

                    {/* Páginas do sistema, atualizam o contexto do sistema */}
                    <Route
                        path="/sistema/*"
                        element={
                            <PrivateRoute>
                                <SistemContextController />
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};
